import produce from "immer";
import margeById from "../../../../helpers/margeById";

export const actions = {
  GET_MY_SUPPLIER_PRIVATE_INQUIREY: "GET_MY_SUPPLIER_PRIVATE_INQUIREY",
  GET_MY_SUPPLIER_PRIVATE_INQUIREY_SUCCESS: "GET_MY_SUPPLIER_PRIVATE_INQUIREY_SUCCESS",
  GET_MY_SUPPLIER_PRIVATE_INQUIRIES: 'GET_MY_SUPPLIER_PRIVATE_INQUIRIES',
  GET_MY_SUPPLIER_PRIVATE_INQUIRIES_SUCCESS: 'GET_MY_SUPPLIER_PRIVATE_INQUIRIES_SUCCESS',
  MY_SUPPLIER_PRIVATE_INQUIREY_IS_LOADING: "MY_SUPPLIER_PRIVATE_INQUIREY_IS_LOADING",
    ADD_PROSPOSAL_BY_SUPPLIER: 'ADD_PROSPOSAL_BY_SUPPLIER',
  ADD_PROSPOSAL_BY_SUPPLIER_SUCCESS: 'ADD_PROSPOSAL_BY_SUPPLIER_SUCCESS',
  GET_MY_SUPPLIER_PROPOSALS: 'GET_MY_SUPPLIER_PROPOSALS',
  GET_MY_SUPPLIER_PROPOSALS_SUCCESS: 'GET_MY_SUPPLIER_PROPOSALS_SUCCESS',
  GET_MY_SUPPLIER_PROPOSAL: 'GET_MY_SUPPLIER_PROPOSAL',
GET_MY_SUPPLIER_PROPOSAL_SUCCESS: 'GET_MY_SUPPLIER_PROPOSAL_SUCCESS',
EDIT_PROPOSAL_BY_SUPPLIER: 'EDIT_PROPOSAL_BY_SUPPLIER',
EDIT_PROPOSAL_BY_SUPPLIER_SUCCESS: 'EDIT_PROPOSAL_BY_SUPPLIER_SUCCESS',
  SET_MY_SUPPLIER_PRIVATE_INQUIRIES_COUNT : 'SET_MY_SUPPLIER_PRIVATE_INQUIRIES_COUNT ',
};

const initalState = {
  items: [],
  isLoading: false,
  count: 0,
  proposals: []
};

export default produce((draft, action) => {
  if (!draft) return initalState;

  const { type, payload } = action;

  switch(type){
    case actions.GET_MY_SUPPLIER_PRIVATE_INQUIRIES_SUCCESS: {
      const currentItems = draft.items
      draft.items = margeById(currentItems, payload)
      break;
    }

    case actions.GET_MY_SUPPLIER_PRIVATE_INQUIREY_SUCCESS : {
        const currentItems = draft.items;
        draft.items = margeById(currentItems , [payload])
        break;
    }

    case actions.MY_SUPPLIER_PRIVATE_INQUIREY_IS_LOADING : {
        draft.isLoading = payload
        break
    }
    case actions.SET_MY_SUPPLIER_PRIVATE_INQUIRIES_COUNT: {
      draft.count = payload;
      break;
    }
    case actions.GET_MY_SUPPLIER_PROPOSALS_SUCCESS : {
      const currentProposals = draft.proposals
      draft.proposals = margeById(currentProposals, payload)
      break;
    }
    case actions.GET_MY_SUPPLIER_PROPOSAL_SUCCESS: {
      const currentProposals = draft.proposals
      draft.proposals = margeById(currentProposals, [payload])
      break;
    }
    case actions.ADD_PROSPOSAL_BY_SUPPLIER_SUCCESS: {
      draft.items = draft.items.filter((item) => item._id !== payload._id)
      // const currentProposals = draft.proposals;
      // draft.proposals = margeById(currentProposals, [payload])
    }
    case actions.EDIT_PROPOSAL_BY_SUPPLIER_SUCCESS: {
        const updatedProposal = payload;
      const targetIndex = draft.items.findIndex(
        (proposal) => proposal._id === updatedProposal._id
      );
      draft.items[targetIndex] = updatedProposal;
      break;
    }

  }

});
